import { type BlockViewProps } from '@plone/types';
import MenuDesktop from '../PageTitleWithMenu/menudesktop';
import MenuMobile from '../PageTitleWithMenu/menumobile';
import { useMediaQuery } from 'usehooks-ts';

export interface PageTitleWithParentMenuData {
  '@type': 'pagetitlewithparentmenu';
  placeholder?: string;
  parent: {
    id: string;
    title: string;
  };
  parent_items: {
    '@id': string;
    id: string;
    title: string;
    exclude_from_nav: boolean;
  }[];
}

type Props = BlockViewProps & {
  data: PageTitleWithParentMenuData;
};

const ViewPageTitleWithParentMenuBlock = ({
  properties,
  metadata,
  data,
}: Props) => {
  const items = data?.parent_items.filter((item) => !item.exclude_from_nav);
  const title = properties.title;
  const parent_id = data?.parent.id;
  const parent_title = data?.parent.title;
  const isMobile = useMediaQuery('(max-width: 1199px)');
  return isMobile ? (
    <MenuMobile
      items={items}
      id={parent_id}
      title={title}
      parent_title={parent_title}
      titleasp={true}
    />
  ) : (
    <MenuDesktop
      items={items}
      isEditMode={false}
      title={title}
      parent_title={parent_title}
      titleasp={true}
    />
  );
};

export default ViewPageTitleWithParentMenuBlock;
